import { configureStore } from '@reduxjs/toolkit';

import authReducer from '../../components/authentication/auth.slice';
import deviceRegistrationReducer from '../../components/deviceRegistration/deviceRegistration.slice';
import grocerylistReducer from '../groceryList/groceryList.slice';
import homepageReducer from '../homepage/homepage.slice';
import mainReducer from '../main/mainSlice';
import mealPlanReducer from '../mealPlan/mealPlan.slice';
import nativeReducer from '../native/native.slice';
import recipeCreationReducer from '../recipeCreation/createRecipe.slice';
import recipeReducer from '../recipePage/recipePage.slice';
import searchReducer from '../search/search.slice';

export const store = configureStore({
  reducer: {
    main: mainReducer,
    homepage: homepageReducer,
    auth: authReducer,
    deviceRegistration: deviceRegistrationReducer,
    recipeCreation: recipeCreationReducer,
    recipePage: recipeReducer,
    search: searchReducer,
    mealPlan: mealPlanReducer,
    groceryList: grocerylistReducer,
    native: nativeReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
